import { Component, OnDestroy, inject, Input, computed, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CryptoSelectComponent } from '../crypto-select/crypto-select.component';
import { MatIcon } from '@angular/material/icon';
import { PaymentStore } from '../../store/payment-report.store';
import { CommonModule } from '@angular/common';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { MatTooltip } from '@angular/material/tooltip';
import { toggleMatTooltipDirective } from 'src/app/directive/toggleMatTooltip.directive';
import { FormatPriceUtils } from 'src/app/utils/format-price-utils';
import { InputMaskUtils } from 'src/app/utils/get-input-mask-util';
import { NickyUserGuestCardComponent } from '../../../../../../components/nicky-user-guest-card/nicky-user-guest-card.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-payment-step',
  imports: [
    CryptoSelectComponent,
    MatIcon,
    FormsModule,
    CommonModule,
    CurrencyMaskModule,
    TranslateModule,
    MatTooltip,
    toggleMatTooltipDirective,
    NickyUserGuestCardComponent,
  ],
  templateUrl: './payment-step.component.html',
})
export class PaymentStepComponent implements OnDestroy {
  // Services
  private readonly toastrService = inject(ToastrService);
  private readonly translate = inject(TranslateService);
  private readonly formatPriceUtils = inject(FormatPriceUtils);
  public readonly getInputMask = inject(InputMaskUtils);

  // Stores
  protected readonly paymentStore = inject(PaymentStore);

  // Inputs/Outputs
  @Input() paymentModal!: boolean;
  onCloseModal = output<boolean>();

  // Local state (minimal - only what can't be moved to store)
  public isCommaDecimal = this.formatPriceUtils.isCommaDecimal();

  ngOnDestroy(): void {
    this.paymentStore.clearTimer();
  }

  // Public methods
  protected getTranslatedString(string: string, params?: any): string {
    return this.translate.instant(string, params);
  }

  public async changeNetwork(enabledNetwork: string): Promise<void> {
    this.toastrService.clear();
    await this.paymentStore.changeNetwork(enabledNetwork);
  }

  public nextStep(): void {
    if (!this.paymentStore.isFormValidComputed()) {
      this.toastrService.error(this.translate.instant('formInvalid'));
      return;
    }
    this.paymentStore.clearTimer();
  }

  onNextInner(): boolean {
    return this.paymentStore.isPaymentStepValidComputed();
  }

  isValidStep(): boolean {
    return this.paymentStore.isPaymentStepValidComputed();
  }
}
